import React from 'react'
import t from 'prop-types'

const IconArrow = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 43 43"
    >
      <g
        className="fill-blue-200 group-hover:fill-blue-100 transition-colors ease-linear duration-200"
        fill="#0096FA"
        fillRule="evenodd"
      >
        <path
          fillRule="nonzero"
          d="M21.5,0.5 C9.90202025,0.5 0.5,9.90202025 0.5,21.5 C0.5,33.0979797 9.90202025,42.5 21.5,42.5 C33.0979797,42.5 42.5,33.0979797 42.5,21.5 C42.5,9.90202025 33.0979797,0.5 21.5,0.5 Z M21.5,3.5 C31.4411255,3.5 39.5,11.5588745 39.5,21.5 C39.5,31.4411255 31.4411255,39.5 21.5,39.5 C11.5588745,39.5 3.5,31.4411255 3.5,21.5 C3.5,11.5588745 11.5588745,3.5 21.5,3.5 Z"
        />
        <path d="M24.4256948,11.5972082 L24.5358541,11.7189254 L32.86687,21.7068097 L24.5710713,32.2376328 C23.8875457,33.1053115 22.630046,33.254597 21.7623672,32.5710713 C20.9380724,31.9217219 20.7621275,30.754361 21.3326316,29.8953222 L21.4289287,29.7623672 L25.967,23.9999503 L12,24 C10.8954305,24 10,23.1045695 10,22 C10,20.8954305 10.8954305,20 12,20 L26.234,19.9999503 L21.4641459,14.2810746 C20.7920038,13.4752572 20.8613437,12.2967497 21.5972082,11.5743052 L21.7189254,11.4641459 C22.5247428,10.7920038 23.7032503,10.8613437 24.4256948,11.5972082 Z" />
      </g>
    </svg>
  )
}

IconArrow.propTypes = {
  width: t.oneOf(t.number, t.string),
  height: t.oneOf(t.number, t.string),
}

IconArrow.defaultProps = {
  width: 43,
  height: 43,
}

export default IconArrow
